import React, { useState, useEffect } from "react";
import { SSLogo } from "../Assets";

const Header = (props) => {
  const [dropDownShow, setDropDownShow] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const Update = () => {
    if (window.scrollY > 100) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", Update);
    return () => {
      window.removeEventListener("scroll", Update);
    };
  }, []);
  return (
    <header
      id="header"
      className="headroom is-sticky"
      style={
        isScrolled
          ? { backgroundColor: "#fff", backgroundImage: "none" }
          : {
              background: "none",
              backgroundImage:
                "url(https://spet-gatsby.envytheme.com/static/banner-bg-ab7c76e43854086c4b5c56942251d5d0.jpg)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center center",
            }
      }
    >
      <div className="startp-nav">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <span className="navbar-brand">
              <span>
                <img
                  src={SSLogo}
                  alt="logo"
                  style={{
                    width: "80px",
                    height: "80px",
                    background: "transparent",
                  }}
                />
              </span>
            </span>

            <button
              className={`${
                dropDownShow
                  ? "navbar-toggler navbar-toggler-right"
                  : "navbar-toggler navbar-toggler-right collapsed"
              } `}
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => {
                setDropDownShow(!dropDownShow);
              }}
            >
              <span className="icon-bar top-bar"></span>
              <span className="icon-bar middle-bar"></span>
              <span className="icon-bar bottom-bar"></span>
            </button>
            <div
              className={` ${
                dropDownShow
                  ? "collapse navbar-collapse show"
                  : "collapse navbar-collapse"
              }`}
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      props.handleScroll("home");
                    }}
                  >
                    Home
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("features")}
                  >
                    Features
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("technologies")}
                  >
                    Technologies
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("team")}
                  >
                    Team
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("aboutUs")}
                  >
                    About us
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("product-list")}
                  >
                    Products
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    aria-current="page"
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("recentStory")}
                  >
                    Our Recent story
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className="nav-link"
                    style={{ cursor: "pointer", marginInline: "5px" }}
                    onClick={() => props.handleScroll("contact-list")}
                  >
                    Contact
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
